import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";

// Response Dto
export interface CountryResponseDto extends IEntityWithSoftDeleteDto {
    name: string;
}

// Form schema
export const countryFormSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: "Name is required" }),
});

export type CountryFormDto = z.infer<typeof countryFormSchema>;
